<template>
  <div>just logged</div>
</template>

<script>

export default {
  data() {
    return {
      val:1,
      scope:this,
    }
  },
  watch: {
    
  },
  mounted() {
    console.log("--",process.env.VUE_APP_SECURE_COOKIE)

  }

}
</script>

<style>

</style>